import * as Yup from 'yup';
import formModel from './formModel';

const {
    emailAddress,
    claimNumber,
    policyNumber,
    contactNumber,
    escalationNote,
    contactMethod,
    claimHandler,
} = formModel;

const validationSchema = Yup.object().shape({
    [claimNumber.name]: Yup.string().required(`${claimNumber.requiredErrorMsg}`),
    [policyNumber.name]: Yup.number()
        .typeError('This field can only contain numbers.')
        .required(`${policyNumber.requiredErrorMsg}`),
    [emailAddress.name]: Yup.string()
        .email('Incorrect email format')
        .required(`${emailAddress.requiredErrorMsg}`),
    [contactNumber.name]: Yup.number()
        .typeError('This field can only contain numbers.'),
    [escalationNote.name]: Yup.string().required(`${escalationNote.requiredErrorMsg}`),
    [contactMethod.name]: Yup.string().required(`${contactMethod.requiredErrorMsg}`),
});

export default validationSchema;
